import React from 'react'
import './index.css'
interface EmptyMsgProps {
    show?: boolean
}
const EmptyMsg: React.FC<EmptyMsgProps> = (props) => {
    if (!props.show) return null
    return <div className='empty-msg'>{props.children}</div>
}

export default EmptyMsg
